module.exports = __webpack_public_path__ + "img/cb4.05a918f4.jpg";